import * as React from 'react'
import {useFormik} from "formik";
import * as yup from "yup";

import GoogleAddressAutocomplete from "../GoogleAddressAutocomplete";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

import {useState} from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";


const AddressAttributeForm = (props) => {
    // TODO add an initial value: it's not easy because of the autocomplete component.
    const {
        label,
        streetValue,
        streetAttributeName="street",
        streetNumberValue,
        streetNumberAttributeName="streetNumber",
        cityValue,
        cityAttributeName="city",
        onClose,
        onSubmit,
        isLoading
    } = props

    const [address, setAddress] = useState();

    const formik = useFormik({
        initialValues: {
            [streetAttributeName]: streetValue || "",
            [streetNumberAttributeName]: streetNumberValue || "",
            [cityAttributeName]: cityValue || "",
        },
        validationSchema: yup.object().shape({
            [streetAttributeName]: yup.string().typeError('Campo non valido').required('Campo obbligatorio'),
            [streetNumberAttributeName]: yup.string().typeError('Campo non valido').required('Campo obbligatorio'),
            [cityAttributeName]: yup.string().typeError('Campo non valido').required('Campo obbligatorio')
        }),
        validateOnMount: true,
        onSubmit: onSubmit,
    });

    const handleAddressChange = (address) => {
        setAddress(address)

        const {street, streetNumber, city} = address;
        formik.setFieldValue(streetAttributeName, street || "");
        formik.setFieldValue(streetNumberAttributeName, streetNumber || "");
        formik.setFieldValue(cityAttributeName, city || "");
    }

    return <Dialog onClose={onClose} open={true} fullWidth>
        <DialogTitle>Aggiorna {label.toLowerCase()}</DialogTitle>
        <DialogContent>
            <Stack spacing={2} sx={{mt: 2}}>
                <GoogleAddressAutocomplete onAddressChange={handleAddressChange}/>
                {
                    address && <>
                        <Typography variant="body1">Conferma indirizzo:</Typography>
                        <TextField label="Via"
                                   fullWidth
                                   size="small"
                                   name={streetAttributeName}
                                   value={formik.values[streetAttributeName]}
                                   onChange={formik.handleChange}
                                   error={formik.touched[streetAttributeName] && Boolean(formik.errors[streetAttributeName])}
                                   helperText={formik.touched[streetAttributeName] && formik.errors[streetAttributeName]}/>

                        <TextField label="Numero civico"
                                   fullWidth
                                   size="small"
                                   name={streetNumberAttributeName}
                                   value={formik.values[streetNumberAttributeName]}
                                   onChange={formik.handleChange}
                                   error={formik.touched[streetNumberAttributeName] && Boolean(formik.errors[streetNumberAttributeName])}
                                   helperText={formik.touched[streetNumberAttributeName] && formik.errors[streetNumberAttributeName]}/>

                        <TextField label="Città"
                                   fullWidth
                                   size="small"
                                   name={cityAttributeName}
                                   value={formik.values[cityAttributeName]}
                                   onChange={formik.handleChange}
                                   error={formik.touched[cityAttributeName] && Boolean(formik.errors[cityAttributeName])}
                                   helperText={formik.touched[cityAttributeName] && formik.errors[cityAttributeName]}/>
                    </>
                }
            </Stack>
        </DialogContent>
        <DialogActions sx={{py: 2, px: 3}}>
            <Button color={"primary"}
                    variant={"text"}
                    onClick={onClose}>
                Cancella
            </Button>
            <LoadingButton onClick={() => formik.handleSubmit()}
                           loading={!!isLoading}
                           variant="contained">
                Salva
            </LoadingButton>
        </DialogActions>
    </Dialog>
}

AddressAttributeForm.propTypes = {
    label: PropTypes.string.isRequired,  // Label of the attribute shown
    streetValue: PropTypes.any,  // Value of the street field of the address
    streetAttributeName: PropTypes.string.isRequired,  // Name of the attribute associated with the street field of the address
    streetNumberValue: PropTypes.any,  // Value of the street number field of the address
    streetNumberAttributeName: PropTypes.string.isRequired,  // Name of the attribute associated with the street number field of the address
    cityValue: PropTypes.any,  // Value of the city field of the address
    cityAttributeName: PropTypes.string,  // Name of the attribute associated with the city field of the address
    onClose: PropTypes.func.isRequired,  // Function called when closing the form
    onSubmit: PropTypes.func.isRequired,  // Function called when submitting the form
    isLoading: PropTypes.bool,
};

export default AddressAttributeForm;